import { apiConnector } from "../apiConnector";
import { toast } from "react-hot-toast";
import { studentFeesEndpoints } from "../apis";

const {
  CREATE_STUDENT_FEES_API,
  UPDATE_STUDENT_FEES_API,
  GET_STUDENT_FEES_API,
  PAY_FEES_API,
  APPLY_DISCOUNT_API,
  SEND_FEES_REMINDER_API,
} = studentFeesEndpoints;

// studentFeesAPI.jsx
export const editStudentFees = async (formData) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      UPDATE_STUDENT_FEES_API, 
      formData,
      { Authorization: `Bearer ${token}` }
    );

    if (!response?.data?.success) {
      toast.error(response?.data?.message || "Failed to update student fees");
      return null;
    }

    toast.success("Student fees updated successfully");
    return response.data.data;
  } catch (error) {
    console.error("EDIT STUDENT FEES API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to update student fees"
    );
    return null;
  }
};


// ===================================================================
// CREATE STUDENT FEES
// ===================================================================
export const createStudentFees = async (formData) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      CREATE_STUDENT_FEES_API,
      formData,
      { Authorization: `Bearer ${token}` }
    );

    if (!response?.data?.success) {
      toast.error(response?.data?.message || "Failed to create student fees");
      return null;
    }

    toast.success("Student fees created successfully");
    return response.data.data;
  } catch (error) {
    console.error("CREATE STUDENT FEES API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to create student fees"
    );
    return null;
  }
};

// ===================================================================
// GET STUDENT FEES (ALL YEARS)
// ===================================================================
export const getStudentFees = async (studentId) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "GET",
      `${GET_STUDENT_FEES_API}/${studentId}`,
      null,
      { Authorization: `Bearer ${token}` }
    );

    if (!response?.data?.success) {
      return null;
    }

    return {
      list: response.data.data,   // array of fees
      count: response.data.count, // total records
    };
  } catch (error) {
    console.error("GET STUDENT FEES API ERROR:", error?.response?.data);
    return null;
  }
};

// ===================================================================
// PAY FEES / INSTALLMENT
// ===================================================================
export const payStudentFees = async (payload) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      PAY_FEES_API,
      payload,
      { Authorization: `Bearer ${token}` }
    );

    if (!response?.data?.success) {
      toast.error(response?.data?.message || "Payment failed");
      return null;
    }

    toast.success("Payment updated successfully");
    return response.data.data;
  } catch (error) {
    console.error("PAY FEES API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to update payment"
    );
    return null;
  }
};

// ===================================================================
// APPLY / UPDATE DISCOUNT
// ===================================================================
export const applyStudentDiscount = async (payload) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      APPLY_DISCOUNT_API,
      payload,
      { Authorization: `Bearer ${token}` }
    );

    if (!response?.data?.success) {
      toast.error(response?.data?.message || "Failed to apply discount");
      return null;
    }

    toast.success("Discount applied successfully");
    return response.data.data;
  } catch (error) {
    console.error("APPLY DISCOUNT API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to apply discount"
    );
    return null;
  }
};

// ===================================================================
// SEND FEES REMINDER
// ===================================================================
export const sendFeesReminder = async (studentFeesId) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      SEND_FEES_REMINDER_API,
      { studentFeesId },
      { Authorization: `Bearer ${token}` }
    );

    if (!response?.data?.success) {
      toast.error(response?.data?.message || "Failed to send reminder");
      return false;
    }

    toast.success("Fees reminder sent successfully");
    return true;
  } catch (error) {
    console.error("SEND FEES REMINDER API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to send fees reminder"
    );
    return false;
  }
};
